'use strict';

// var req = require.context('../images', true, /^(.*\.(jpg|png$))[^.]*$/igm);
// req.keys().forEach(function(key){
//   req(key);
// });

import '../sass/main.scss';

import './console_mock';

import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import ngCookies from 'angular-cookies';
import ngAnimate from 'angular-animate';
import uiRouter from 'angular-ui-router';
import oclazyLoad from 'oclazyload';

import angularTranslate from 'angular-translate';
import 'angular-translate-interpolation-messageformat';
import angularElastic from 'angular-elastic';

// problematic
// import angularRaven from 'exports-loader?\'ngRaven\'!angular-raven';
import uiRouterExtras from 'imports-loader?angular!exports-loader?\'ct.ui.router.extras\'!ui-router-extras';
import angularSocket from 'exports-loader?\'btford.socket-io\'!angular-socket-io';

import ngScrollbar from 'exports-loader?\'ngScrollbar\'!ng-scrollbar';

// Translations
import translate from './translate';
import './nls';

// Common modules
import carousel from './common/carousel';
import contactForm from './common/contact_form';
import fetchErrorMessage from './common/fetch_error_message';
import howItWorks from './common/how_it_works';
import introVideos from './common/intro_videos';
import locationSearch from './common/location_search';
import navigation from './common/navigation';
import recentBookings from './common/recent_bookings';
import slideshow from './common/slideshow';
import socialLinks from './common/social_links';
import supportEmail from './common/support_email';
import topPanel from './common/top_panel';
import getStarted from './modules/settings/get_started';
import tooltipModule from './directives/tooltip.directive';
import common from './common';

//Services
import remarketing from './services/remarketing.service';
import fbCampaignHandler from './services/fb_campaign_handler.service';

import constants from './constants';
import filters from './filters';
import components from './components';
import directives from './directives';
import models from './models';
import resources from './resources';
import services from './services';

import photoModel from './models/photo_model';
import tripsService from './components/trips/trips/services/trips';
import dashboardService from './modules/dashboard/dashboard.service';
import notificationSettingsService from './modules/notification_settings/notification_settings.service';

// Feature modules
import activation from './modules/activation';
import autologin from './modules/autologin';
import becomeGuide from './modules/become_guide';
import forgotPassword from './modules/forgot_password';
import join from './modules/join';
import mailing from './modules/mailing';
import membership from './modules/membership';
import passwordForm from './modules/password_form';
import loginHistory from './modules/login_history';
import userId from './modules/user_id';
import vkLogin from './modules/vk_login';

import infoBox from './modules/info_box/info_box';
import overflow from './modules/overflow/overflow';

import appConfig from './app.config';
import appRun from './app.run';

// import './raven';

export default angular
  .module('app', [

    // 3rd party modules
    ngSanitize,
    ngMessages,
    ngCookies,
    ngAnimate,
    uiRouter,
    uiRouterExtras,
    angularSocket,
    angularTranslate,
    angularElastic,
    oclazyLoad,
    ngScrollbar,

    remarketing,
    fbCampaignHandler,

    // TODO: refactor
    constants,
    components,
    directives,
    filters,
    models,
    photoModel,
    tripsService,
    dashboardService,
    notificationSettingsService,
    resources,
    services,
    translate,

    // Common modules
    common,
    carousel,
    contactForm,
    fetchErrorMessage,
    howItWorks,
    introVideos,
    locationSearch,
    navigation,
    recentBookings,
    slideshow,
    socialLinks,
    supportEmail,
    topPanel,
    getStarted,
    tooltipModule,
    infoBox,
    overflow,

    // Feature modules
    activation,
    autologin,
    becomeGuide,
    forgotPassword,
    join,
    mailing,
    membership,
    passwordForm,
    loginHistory,
    userId,
    vkLogin
  ])
  .config(appConfig)
  .run(appRun)
  .name;

angular.element(document).ready(function() {
  angular.bootstrap(document, ['app'], { strictDi: true });
});



// WEBPACK FOOTER //
// ./app/src/app.js